import styled from 'styled-components';
var StyledNavbarBadge = styled.span.withConfig({
  displayName: "NavbarBadgestyles__StyledNavbarBadge"
})(["display:inline-flex;padding:2px 6px;font-size:11px;font-weight:600;justify-content:center;align-items:center;white-space:nowrap;box-sizing:border-box;vertical-align:baseline;border-radius:99px;flex:0 0 24px;background-color:", ";color:", ";margin-left:6px;"], function (_ref) {
  var isDark = _ref.isDark;
  return isDark ? '#D1D5DB' : '#374151';
}, function (_ref2) {
  var isDark = _ref2.isDark;
  return isDark ? '#1F2937' : '#f3f4f6';
});
export { StyledNavbarBadge };